import type { BackgroundCheckOrder } from "./types";

export function canCreateBackgroundCheckOrder(order: BackgroundCheckOrder | null | undefined): boolean {
  if (!order) return true;
  return order.staffInvitationCreatable === true;
}

export function canSendBackgroundCheckInvitation(order: BackgroundCheckOrder | null | undefined): boolean {
  return order?.staffInvitationEmailable === true;
}
